import useLocalStorage from '../hooks/useLocalStorage';
import { useEffect } from 'react';
import '../styling/ThemeSwitcher.css';

const ThemeSwitcher = () => {
  const defaultDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const [theme, setTheme] = useLocalStorage('robin-portfolio.theme', defaultDark ? "dark" : "light");

  useEffect(() => {
    // Set Bootstrap data attribute for dark mode
    document.documentElement.setAttribute('data-bs-theme', theme);
    
    // Also set our custom data-theme attribute for consistency
    document.documentElement.setAttribute('data-theme', theme);
    
    // Set color-scheme for native elements
    document.documentElement.setAttribute('color-scheme', theme);
    
    // Store in localStorage for persistence
    localStorage.setItem('robin-portfolio.theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  return (
    <div className="theme-switcher-wrapper">
      <button
        className="theme-switcher-btn"
        aria-label={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
        role="switch"
        aria-checked={theme === "dark"}
        onClick={toggleTheme}
        title={`Switch to ${theme === "light" ? "dark" : "light"} mode`}
      >
        <div className="switcher-track">
          <span className="switcher-thumb">
            {theme === "dark" ? (
              <i className="bi bi-brightness-high"></i>
            ) : (
              <i className="bi bi-moon"></i>
            )}
          </span>
        </div>
        <span className="switcher-label">
          {theme === "dark" ? "Light" : "Dark"}
        </span>
      </button>
    </div>
  );
};

export default ThemeSwitcher;